var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 676 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.224 53.6672L237.43 73.3925M335.095 7V33.9419M452.965 53.6672L436.127 73.3925M172 173.943H199.423M508.774 173.943H480.388M459.22 285.079L436.127 263.91M335.095 309.134V336.076M237.43 273.051L217.224 298.55",
    stroke: "#E7F4FC",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.964 87.0215C420.864 76.1502 418.675 65.3969 414.512 55.3482C410.251 45.0598 404.004 35.7116 396.13 27.8372C388.256 19.9629 378.907 13.7166 368.619 9.45498C358.331 5.19341 347.304 3 336.168 3C325.032 3 314.005 5.19341 303.716 9.45499C293.428 13.7166 284.08 19.9629 276.205 27.8372C268.331 35.7116 262.085 45.0598 257.823 55.3482C253.661 65.3969 251.471 76.1502 251.372 87.0215H251.368V157.04H285.599V87.0215H284.162C284.261 80.4562 285.601 73.9664 288.116 67.8958C290.729 61.5856 294.561 55.8519 299.39 51.0222C304.22 46.1925 309.954 42.3614 316.264 39.7476C322.574 37.1338 329.337 35.7885 336.168 35.7885C342.998 35.7885 349.761 37.1338 356.071 39.7476C362.382 42.3614 368.115 46.1925 372.945 51.0222C377.775 55.8519 381.606 61.5856 384.22 67.8958C386.734 73.9664 388.075 80.4562 388.173 87.0215H386.737V157.04H420.968V87.0215H420.964Z",
    fill: "#423D56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.291 83.9097C402.186 75.8992 400.46 67.9784 397.203 60.5726C393.841 52.9271 388.913 45.9802 382.7 40.1287C376.487 34.2771 369.111 29.6353 360.994 26.4685C352.876 23.3016 344.176 21.6716 335.39 21.6716C326.604 21.6716 317.904 23.3016 309.786 26.4685C301.669 29.6353 294.293 34.2771 288.08 40.1287C281.867 45.9803 276.939 52.9271 273.577 60.5726C270.32 67.9784 268.594 75.8992 268.489 83.9097H268.484V157.04H285.957V84.1421C286.031 78.2132 287.306 72.3503 289.717 66.8693C292.201 61.2201 295.843 56.0871 300.433 51.7634C305.024 47.4397 310.474 44.01 316.472 41.67C322.469 39.33 328.898 38.1256 335.39 38.1256C341.882 38.1256 348.311 39.33 354.309 41.67C360.306 44.01 365.756 47.4397 370.347 51.7634C374.937 56.0871 378.579 61.2201 381.063 66.8693C383.548 72.5185 384.826 78.5732 384.826 84.6878H384.839V157.04H402.312V83.9097H402.291Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.647 100.509C227.363 100.509 220.647 107.225 220.647 115.509V247.328C220.647 247.5 220.65 247.67 220.656 247.84C220.649 248.002 220.646 248.163 220.646 248.325C220.646 250.687 221.394 252.952 222.82 255.108C223.764 256.662 224.983 258.031 226.409 259.147C241.664 272.669 285.395 281 335.786 281C398.517 281 449.371 268.089 449.371 248.325C449.371 248.179 449.368 248.033 449.363 247.888C449.37 247.702 449.373 247.516 449.373 247.328V115.509C449.373 107.225 442.657 100.509 434.373 100.509H235.647Z",
    fill: "#00BFF3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 100,
    width: 230,
    height: 181
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.647 100.509C227.363 100.509 220.647 107.225 220.647 115.509V248.117C220.646 248.186 220.646 248.255 220.646 248.325C220.646 248.394 220.646 248.464 220.647 248.533V252.328C220.647 257.851 225.125 262.328 230.647 262.328H230.664C248.791 273.964 289.476 281 335.786 281C398.517 281 449.371 268.089 449.371 248.325C449.371 248.179 449.368 248.033 449.363 247.888C449.37 247.702 449.373 247.516 449.373 247.328V115.509C449.373 107.225 442.657 100.509 434.373 100.509H235.647Z",
    fill: "#FFCA28"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.787,
    y: 91.1732,
    width: 143.148,
    height: 199.162,
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.764 188.663C355.911 184.288 360.68 176.408 360.68 167.415C360.68 153.666 349.534 142.52 335.784 142.52C322.035 142.52 310.889 153.666 310.889 167.415C310.889 176.062 315.298 183.679 321.989 188.142L317.324 236.798C317.211 237.973 318.135 238.989 319.315 238.989H350.73C351.899 238.989 352.819 237.99 352.723 236.825L348.764 188.663Z",
    fill: "#3F3D56"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 195.736,
    width: 91.6686,
    height: 24.5541,
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 208.013,
    width: 94.9425,
    height: 12.277,
    fill: "#FFA120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.509 207.603C491.509 227.267 475.569 243.207 455.906 243.207C436.242 243.207 420.302 227.267 420.302 207.603C420.302 187.94 436.242 172 455.906 172C475.569 172 491.509 187.94 491.509 207.603ZM442.304 207.603C442.304 215.115 448.394 221.205 455.906 221.205C463.418 221.205 469.507 215.115 469.507 207.603C469.507 200.091 463.418 194.002 455.906 194.002C448.394 194.002 442.304 200.091 442.304 207.603Z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.548,
    y: 217.016,
    width: 11.4586,
    height: 17.1879,
    fill: "#FFA120"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.373,
    y: 217.016,
    width: 11.4586,
    height: 17.1879,
    fill: "#FFA120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 189.865H46.3474M565.46 91.2383L579.893 70.5508M630.409 140.792L656.389 128.765M621.268 230.278L646.767 243.268",
    stroke: "#01BFF3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.739,
    cy: 191.789,
    r: 6.25437,
    fill: "#01BFF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.831,
    cy: 285.123,
    r: 7.21658,
    fill: "#01BFF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.3569,
    cy: 123.953,
    r: 7.69768,
    fill: "#01BFF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.397,
    cy: 234.126,
    r: 6.25437,
    fill: "#01BFF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.249,
    cy: 286.086,
    r: 6.25437,
    fill: "#505263"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.102,
    cy: 153.782,
    r: 9.6221,
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.288,
    cy: 275.982,
    r: 9.6221,
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7315 80.1725C74.7315 80.1725 71.9623 90.2803 76.1748 93.1623C81.1755 96.5836 84.1965 82.8157 89.6458 85.4646C95.4009 88.2623 84.5506 99.7591 90.608 101.822C95.5495 103.505 98.7802 93.0767 103.598 95.0867C107.631 96.7694 105.522 104.709 105.522 104.709",
    stroke: "#E1E1E1",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.633 201.716C600.633 201.716 600.663 191.236 595.843 189.555C590.122 187.561 590.806 201.64 584.854 200.508C578.567 199.312 586.034 185.378 579.648 184.971C574.438 184.638 574.047 195.549 568.871 194.868C564.538 194.299 564.498 186.084 564.498 186.084",
    stroke: "#037DBA",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.0144,
    y: 147.143,
    width: 13.4709,
    height: 13.4709,
    transform: "rotate(45 93.0144 147.143)",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1396,
    y: 236.074,
    width: 13.4709,
    height: 13.4709,
    transform: "rotate(-13.1907 56.1396 236.074)",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.954,
    y: 87.5765,
    width: 13.4709,
    height: 13.4709,
    transform: "rotate(-13.1907 501.954 87.5765)",
    fill: "#00BFF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.404,
    y: 239.272,
    width: 13.4709,
    height: 13.4709,
    transform: "rotate(-13.1907 541.404 239.272)",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.973,
    cy: 148.97,
    r: 6.73547,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.335 81.3747L165.806 102.062L149.755 107.377L152.335 81.3747Z",
    fill: "#E7F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.373 122.51L588.551 106.988L600.579 122.51L580.373 122.51Z",
    fill: "#E7F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.895 194.756L661.999 183.091L644.045 175.141L648.895 194.756Z",
    fill: "#E7F4FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 154.5,
    y: 0.5,
    width: 371.774,
    height: 364.076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 206.646,
    y: 0,
    width: 256.728,
    height: 306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0.5,
    y: 65.0505,
    width: 675.5,
    height: 252.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.d579e056.svg";
export { ForwardRef as ReactComponent };